// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l9i2a3KK2h0efAMuHURZ {
  background-color: #F8FAFF;
  min-height: calc(100vh - 75px);
  width: 65%;
}

.eEQZPwnvDSlBXzqraOBV {
  width: 100%;
  margin: auto;
  position: relative;
  background: linear-gradient(90deg, rgba(248,250,255,1) 0%, rgba(248,250,255,1) 35%, rgba(255,255,255,1) 100%);
}

.AFhkrcADtP3Dm1V1UkDC {
  width: 100%;
  max-width: 1440px;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  position: relative;
  z-index: 0;
}

.ApUKJvSDdfvuIlFWKDLw {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 24px;
}

.EixD5majexDarykpitmX {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;

  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(0, 0, 0, 0.15);
}

._Ob4qdOooHMnhK8TAW_b {
  background-color: white;
  border-radius: 5px;
  width: 550px;
  padding: 24px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

._Ob4qdOooHMnhK8TAW_b button {
  width: 100%;
}

.Zc6jAmIfudG6gxAjLhjR {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 16px;
}

.wKVv7SHxW_s1r05SlNpE {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: rgba(0, 0, 0, 0.55);
  margin: 0 0 24px 0;
}

.aNA40dN02aB521fdmDZV {
  background-color: #FAEDED;

  width: 80px;
  height: 80px;
  border-radius: 80px;
  margin-bottom: 8px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.VFciqVMsIkTjn4pJOuMk {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-error"]};
  font-size: 36px !important;
}

.v_lC9ZldEYOdRJxAU3mJ {
  font-size: 16px;
  letter-spacing: 0.005em;
}

@media screen and (max-width: 1440px) {
  .AFhkrcADtP3Dm1V1UkDC {
    width: 90%;
  }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .AFhkrcADtP3Dm1V1UkDC {
    flex-direction: column-reverse;
  }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
  ._Ob4qdOooHMnhK8TAW_b {
    width: 90%;
    box-sizing: border-box;
  }

  .aNA40dN02aB521fdmDZV {
    width: 60px;
    height: 60px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Payements/payements.module.css"],"names":[],"mappings":"AAMA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6GAA6G;AAC/G;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;;EAEb,WAAW;EACX,aAAa;;EAEb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;;EAEtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;;EAEzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;;EAElB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mDAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet-l, tablet, mobile, mobile-xs from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-gray, color-text-subtle, color-error-light, color-error from colors;\n\n.container {\n  background-color: #F8FAFF;\n  min-height: calc(100vh - 75px);\n  width: 65%;\n}\n\n.content {\n  width: 100%;\n  margin: auto;\n  position: relative;\n  background: linear-gradient(90deg, rgba(248,250,255,1) 0%, rgba(248,250,255,1) 35%, rgba(255,255,255,1) 100%);\n}\n\n.row {\n  width: 100%;\n  max-width: 1440px;\n  margin: auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  position: relative;\n  z-index: 0;\n}\n\n.buttonGroup {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-bottom: 24px;\n}\n\n.background {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1000;\n\n  width: 100%;\n  height: 100vh;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n.modal {\n  background-color: white;\n  border-radius: 5px;\n  width: 550px;\n  padding: 24px;\n  box-sizing: border-box;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal button {\n  width: 100%;\n}\n\n.title {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  margin-bottom: 16px;\n}\n\n.description {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  text-align: center;\n  color: rgba(0, 0, 0, 0.55);\n  margin: 0 0 24px 0;\n}\n\n.error {\n  background-color: #FAEDED;\n\n  width: 80px;\n  height: 80px;\n  border-radius: 80px;\n  margin-bottom: 8px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.icon {\n  color: color-error;\n  font-size: 36px !important;\n}\n\n.button {\n  font-size: 16px;\n  letter-spacing: 0.005em;\n}\n\n@media screen and (max-width: 1440px) {\n  .row {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: tablet-l) {\n  .row {\n    flex-direction: column-reverse;\n  }\n}\n\n@media screen and (max-width: tablet) {\n  .modal {\n    width: 90%;\n    box-sizing: border-box;\n  }\n\n  .error {\n    width: 60px;\n    height: 60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["laptop"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple-bg"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]}`,
	"color-error-light": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-error-light"]}`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-error"]}`,
	"container": `l9i2a3KK2h0efAMuHURZ`,
	"content": `eEQZPwnvDSlBXzqraOBV`,
	"row": `AFhkrcADtP3Dm1V1UkDC`,
	"buttonGroup": `ApUKJvSDdfvuIlFWKDLw`,
	"background": `EixD5majexDarykpitmX`,
	"modal": `_Ob4qdOooHMnhK8TAW_b`,
	"title": `Zc6jAmIfudG6gxAjLhjR`,
	"description": `wKVv7SHxW_s1r05SlNpE`,
	"error": `aNA40dN02aB521fdmDZV`,
	"icon": `VFciqVMsIkTjn4pJOuMk`,
	"button": `v_lC9ZldEYOdRJxAU3mJ`
};
export default ___CSS_LOADER_EXPORT___;
